import React from 'react'
import { IconContext } from "react-icons";
import { FaEnvelopeOpenText, FaLocationDot, FaMobileScreenButton, FaPhone,  } from 'react-icons/fa6';
import {Helmet} from 'react-helmet-async'
//import  Map from '../components/Map'

function Contact() {

  /* const location={
    address: '40 Capmartin Road, Coventry CV6 3FY, UK',
    lat: 52.4279443,
    lng: -1.5136305, */
//}
  return (
    <div>

<Helmet>
            <title>Veemu HealthCare Contacts</title>
            <meta name="description" content="Get in touch with us in the provided contact information"/>
            <link rel="canonical" href="/contact" />
        </Helmet>
        <section>
            <div class=" lg:px-4 mx-auto max-w-screen-xl t pt-4">

                <div class="lg:px-4 mx-auto max-w-screen-xl text-center pt-6  ">
                    <h4 class="mb-4 text-1xl font-extrabold tracking-tight leading-none text-fuchsia-950 md:text-3xl lg:text-3xl">
                    Contacting VEEMU HealthCare
                    </h4>
                </div> 

                <div class="sm:flex sm:items-center sm:justify-center lg:mx-8 mt-2 px-5">
                  <p class=" font-normal text-sm md:text-lg text-fuchsia-950">
                      To request more information, please give us a call or email us. We would love to speak to you regarding
                      our experienced support carers that can help you deliver excellent services to your business and clients.
                  
                  </p>
                  <br/>
            
                </div>

                <center>
                <div class="max-w-fit sm:82 rounded-lg  items-center sm:items-center sm:justify-center mx-4  lg:mx-8 mt-1">

                    <div class="max-w-fit  sm:82 rounded-lg   sm:items-center sm:justify-center py-4 lg:ml-48 mt-8">

                        <IconContext.Provider value={{ color: '#ff0000', size: '50px', padding:'5px 2px' }}>
                            <a href="mailto:info@veemuhealthcare.co.uk"><div class="  sm:items-center sm:justify-center  mx-5 mt-5 mb-5">
                            
                            <FaEnvelopeOpenText class="sm:items-center sm:justify-center mx-6 my-6"/>
                            </div></a>
                          </IconContext.Provider>
                          <div class="  sm:items-center sm:justify-center  mt-1">
                            <p class=" text-1xl font-normal">
                            <div><span class="text-black text-2xl font-bold"><a href="mailto:info@veemuhealthcare.co.uk" className="block py-2 pl-3 pr-4 underline text-navcolour rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Email Us</a></span></div>
                            info@veemuhealthcare.co.uk

                            </p>
                          </div>
                    </div>

                    <div class="max-w-fit  sm:82 rounded-lg  sm:items-center sm:justify-center py-4  lg:ml-48 mt-8">

                          <IconContext.Provider value={{ color: '#231f32', size: '50px', padding:'5px 2px' }}>
                            <a href="tel:07427494551"><div class="  sm:items-center sm:justify-center   mt-5 mb-5">
                              <FaMobileScreenButton class="sm:items-center sm:justify-center  my-6"/>
                            </div></a>
                          </IconContext.Provider>
                          <div class="  sm:items-center sm:justify-center   mt-1">
                            <p class=" text-1xl font-normal">
                            <div><span class="text-black  "><a href="tel:07427494551" 
                            className="block py-2  underline text-black rounded hover:bg-gray-100 md:hover:bg-transparent 
                            md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700
                             dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Mobile: 07427494551</a></span></div>
                            
                            </p>
                          </div>

                          

                    </div>

                    <div class="max-w-fit  sm:82 rounded-lg  sm:items-center sm:justify-center py-4  lg:ml-48 mt-8">

                          <IconContext.Provider value={{ color: '#231f32', size: '50px', padding:'5px 2px' }}>
                            <a href="tel:07383378233"><div class="  sm:items-center sm:justify-center   mt-5 mb-5">
                              <FaMobileScreenButton class="sm:items-center sm:justify-center  my-6"/>
                            </div></a>
                          </IconContext.Provider>
                          

                          <div class="  sm:items-center sm:justify-center   mt-1">
                            <p class=" text-1xl font-normal">
                            <div><span class="text-black  "><a href="tel:07383378233" 
                            className="block py-2  underline text-black rounded hover:bg-gray-100 md:hover:bg-transparent 
                            md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700
                             dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Mobile: 0738 337 8233</a></span></div>
                            

                            </p>
                          </div>

                    </div> 

                    <div class="max-w-fit  sm:82 rounded-lg  sm:items-center sm:justify-center py-4  lg:ml-48 mt-8">

                          <IconContext.Provider value={{ color: '#339933', size: '50px', padding:'5px 2px' }}>
                            <a href="tel:02035240955"><div class="  sm:items-center sm:justify-center   mt-5 mb-5">
                              <FaPhone class="sm:items-center sm:justify-center  my-6"/>
                            </div></a>
                          </IconContext.Provider>
                          <div class="  sm:items-center sm:justify-center   mt-1">
                            <p class=" text-1xl font-normal">
                            <div><span class="text-black "><a href="tel:02477981121" 
                            className="block py-2  underline text-black rounded hover:bg-gray-100 md:hover:bg-transparent 
                            md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700
                             dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">London Office Landline:  0203 524 0955</a></span></div>
                          
                            </p>
                          </div>

                    </div>

                    <div class="max-w-fit  sm:82 rounded-lg  sm:items-center sm:justify-center py-4  lg:ml-48 mt-8">

                          <IconContext.Provider value={{ color: '#339933', size: '50px', padding:'5px 2px' }}>
                            <a href="tel:01252958421"><div class="  sm:items-center sm:justify-center   mt-5 mb-5">
                              <FaPhone class="sm:items-center sm:justify-center  my-6"/>
                            </div></a>
                          </IconContext.Provider>
                          <div class="  sm:items-center sm:justify-center   mt-1">
                            <p class=" text-1xl font-normal">
                            <div><span class="text-black "><a href="tel:02477981121" 
                            className="block py-2  underline text-black rounded hover:bg-gray-100 md:hover:bg-transparent 
                            md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700
                             dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Hampshire Office Landline: 0125 295 8421</a></span></div>
                          
                            </p>
                          </div>

                    </div>


                    <div class="max-w-fit  sm:82 rounded-lg  sm:items-center sm:justify-center py-4  lg:ml-48 mt-8">

                          <IconContext.Provider value={{ color: '#89cff0', size: '50px', padding:'5px 2px' }}>
                            <a href="https://www.google.com/maps/place/19+Albert+Square,+London+E15+1HJ,+UK/@51.6118925,0.0336148,11z"><div class="  sm:items-center sm:justify-center   mt-5 mb-5">
                              <FaLocationDot class="sm:items-center sm:justify-center  my-6"/>
                            </div></a>
                          </IconContext.Provider>
                          <div class="  sm:items-center sm:justify-center   mt-1">
                            <p class=" text-1xl font-normal">
                              <div>
                                <span class="text-black text-2xl font-bold">
                                  <a href="https://www.google.com/maps/place/19+Albert+Square,+London+E15+1HJ,+UK/@51.6118925,0.0336148,11z" 
                                      className="block py-2  underline text-navcolour rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Visit Us</a></span></div>
                                      VEEMU HealthCare Limited<br/>19 Albert Square<br/>
                                      Stratford 
                                      London
                                      <br/>E15 1HJ
                            </p>
                          </div>

                    </div>


                    <div class="max-w-fit  sm:82 rounded-lg  sm:items-center sm:justify-center py-4  lg:ml-48 mt-8">

                      <IconContext.Provider value={{ color: '#89cff0', size: '50px', padding:'5px 2px' }}>
                        <a href="https://www.google.com/maps/place/Regus/@51.2968578,-0.8197451,17z"><div class="  sm:items-center sm:justify-center   mt-5 mb-5">
                          <FaLocationDot class="sm:items-center sm:justify-center  my-6"/>
                        </div></a>
                      </IconContext.Provider>
                      <div class="  sm:items-center sm:justify-center   mt-1">
                        <p class=" text-1xl font-normal">
                          <div>
                            <span class="text-black text-2xl font-bold">
                              <a href="https://www.google.com/maps/place/Regus/@51.2968578,-0.8197451,17z" 
                                  className="block py-2  underline text-navcolour rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-navcolour dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Visit Us</a></span></div>
                                  VEEMU HealthCare Limited<br/>114 Centaur House<br/>
                                  Ancells Business Park
                                  Ancells Rd 
                                  <br/>GU51 2UJ
                        </p>
                      </div>

                     </div>


                </div>

                </center>

        
         
         <div>

         {/* <MapSection location={location} zoomLevel={17} /> */}
         </div>
            
          

            </div>
        </section>
    </div>
  )
}

export default Contact